export const DOCUMENT_UPLOAD_PATH = '/document-upload';

export const openDocumentUploadBucket = () => {
  window.location.href = DOCUMENT_UPLOAD_PATH;
};
